"use client";
import {
  __async
} from "../chunk-GOCCUU3Z.js";
import { useCallback, useState } from "react";
function useCopyToClipboard() {
  const [copied, setCopied] = useState(false);
  const clearState = () => {
    setTimeout(() => {
      setCopied(false);
    }, 3e3);
  };
  const copy = useCallback((text) => __async(this, null, function* () {
    if (typeof navigator === "undefined") {
      return;
    }
    if (!(navigator == null ? void 0 : navigator.clipboard)) {
      console.warn("Clipboard not supported");
      return false;
    }
    try {
      yield navigator.clipboard.writeText(text);
      setCopied(true);
      clearState();
      return true;
    } catch (error) {
      console.warn("Copy failed", error);
      setCopied(false);
      return false;
    }
  }), []);
  return [copied, copy];
}
export {
  useCopyToClipboard
};
